export const leaveTypesThatAllowPlusTime = ['vacation', 'leave'];
